import http from "./HttpService";
import moment from "jalali-moment";

const endpoint = process.env.VUE_APP_BASE_URL;


export const updateUserRole = (accountId, role) => {
  return http.put(`/Accounts/${accountId}/role`, {
    role,
  }, {
    baseURL: endpoint,
  });
};

export const userMigrationFromPerfectCrypto = (accountId) => {
  return http.put(`/Accounts/${accountId}/perfectCrypto/migration/manual`, {}, {
    baseURL: endpoint,
  });
};

export function fetchUserAccount(userId) {
  return http.get(`/Accounts/${userId}`, {
    baseURL: endpoint
  });
}

export function attemptLoginAdminLikeUser(accountId) {
  return http.post(`/Auth/login/admin-like-user`, {
      accountId
    },
    {
      baseURL: endpoint
    });
}

export function logoutFromAllDeviceUser(accountId) {
  return http.post(`/Auth/logout/account/${accountId}`, {},
    {
      baseURL: endpoint
    });
}

export  function refreshToken() {
  return  http.post('/Auth/refresh-token');
}
